<template>
  <b-modal
    id="self-clock-in-modal"
    modal-class="timesheet-modal"
    title="Clock In"
    ok-title="Clock In"
    :ok-disabled="!canSubmit || submitting"
    :busy="submitting"
    @ok.prevent="submit"
    @hidden="reset"
    @shown="onShown"
  >
    <b-form-group label="Project">
      <div v-if="!projects.length" class="text-muted small">
        No projects available
      </div>
      <b-form-select
        v-else
        v-model="projectId"
        :options="projectOptions"
        :disabled="submitting"
      />
    </b-form-group>

    <b-form-group v-if="supervisorOptions.length > 1" label="Supervisor">
      <b-form-select
        v-model="supervisorId"
        :options="supervisorOptions"
        :disabled="submitting"
      />
    </b-form-group>

    <div class="geofence-line text-muted small mb-2">
      <b-icon icon="geo-alt" class="mr-1" />
      {{ geofence.label }}
    </div>

    <b-alert :show="!!error" variant="danger">{{ error }}</b-alert>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'
import { geofenceLabel, tryGetPosition } from '@/utils/geofence'

export default {
  name: 'ClockInDialog',

  props: {
    projects: { type: Array, default: () => [] },
  },

  data() {
    return {
      projectId: null,
      supervisorId: null,
      position: null,
      geofence: { label: 'Location unavailable', zoneId: null },
      submitting: false,
      error: null,
    }
  },

  computed: {
    projectOptions() {
      return this.projects.map((p) => ({ value: p.id, text: p.name }))
    },

    selectedProject() {
      return this.projects.find((p) => p.id === this.projectId) || null
    },

    supervisorOptions() {
      const supervisors =
        (this.selectedProject && this.selectedProject.supervisors) || []
      return supervisors.map((s) => ({ value: s.id, text: s.name }))
    },

    canSubmit() {
      return !!this.projectId
    },
  },

  watch: {
    projectId() {
      this.autoSelectSupervisor()
      this.recomputeGeofence()
    },
  },

  methods: {
    ...mapActions('timesheet', ['clockInSelf']),

    async onShown() {
      if (this.projects.length === 1) {
        this.projectId = this.projects[0].id
      }
      this.position = await tryGetPosition()
      this.recomputeGeofence()
    },

    autoSelectSupervisor() {
      const options = this.supervisorOptions
      this.supervisorId = options.length === 1 ? options[0].value : null
    },

    recomputeGeofence() {
      const zones = (this.selectedProject && this.selectedProject.zones) || []
      this.geofence = this.position
        ? geofenceLabel(zones, this.position.lat, this.position.lng)
        : { label: 'Location unavailable', zoneId: null }
    },

    async submit() {
      if (!this.canSubmit || this.submitting) return
      this.submitting = true
      this.error = null

      try {
        const event = await this.clockInSelf({
          project_id: this.projectId,
          lat: this.position ? this.position.lat : 0,
          lng: this.position ? this.position.lng : 0,
          supervisor_id: this.supervisorId || null,
        })
        this.$emit('clocked-in', event)
        this.$bvModal.hide('self-clock-in-modal')
      } catch (e) {
        this.error =
          (e.response && e.response.data && e.response.data.message) ||
          'Something went wrong clocking in - try again.'
      } finally {
        this.submitting = false
      }
    },

    reset() {
      this.projectId = null
      this.supervisorId = null
      this.position = null
      this.geofence = { label: 'Location unavailable', zoneId: null }
      this.error = null
    },
  },
}
</script>
